import { createSlice } from "@reduxjs/toolkit";
import {
  createCaseTagsAction,
  updateCaseTagsAction,
  getCaseTagsAction,
  deleteCaseTagsAction,
  CheckCaseTagswithCaseDetailsAPIAction,
} from "../../actions/CaseTags/caseTagsAction";

const initialState = {
  caseTags: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const caseTagsSlice = createSlice({
  name: "caseTags",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseTagsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCaseTagsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.caseTags = action.payload.caseTagsDetails || [];
      })
      .addCase(getCaseTagsAction.rejected, (state, action) => {
        state.loading = false;
        state.caseTags = action.payload;
      });
    builder
      .addCase(createCaseTagsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCaseTagsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Case Tag created successfully";
        state.caseTags.push(action.payload.data);
      })
      .addCase(createCaseTagsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateCaseTagsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCaseTagsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Case Tag updated successfully";

        const index = state.caseTags.findIndex(
          (c) => c.caseTags_ID === action.payload.data.caseTags_ID,
        );

        if (index !== -1) {
          state.caseTags[index] = action.payload.data;
        }
      })
      .addCase(updateCaseTagsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(CheckCaseTagswithCaseDetailsAPIAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        CheckCaseTagswithCaseDetailsAPIAction.fulfilled,
        (state, action) => {
          state.loading = false;
          // state.success = true;
          // state.successMessage = "Case Tag deleted successfully";
          // state.message = message;
          state.successMessage =
            action.payload?.message || "case Tag Checked successfully";
        },
      )
      .addCase(
        CheckCaseTagswithCaseDetailsAPIAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
    builder
      .addCase(deleteCaseTagsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCaseTagsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        // state.successMessage = "Case Tag deleted successfully";
        // state.message = message;
        state.successMessage =
          action.payload?.message || "Case Tag deleted successfully";

        state.caseTags = state.caseTags.filter(
          (c) => c.caseTags_ID !== action.payload,
        );
      })
      .addCase(deleteCaseTagsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = caseTagsSlice.actions;
export default caseTagsSlice.reducer;
